'use client';
import { jsx } from 'react/jsx-runtime';
import { omitThemingProps } from '@chakra-ui/styled-system';
import { SelectContextProvider, SelectStylesProvider } from './select-context.mjs';
import { splitFieldProps } from '../field/field-props.mjs';
import { useField } from '../field/use-field.mjs';
import { forwardRef } from '../system/forward-ref.mjs';
import { useMultiStyleConfig } from '../system/use-style-config.mjs';
import { chakra } from '../system/factory.mjs';

const NativeSelectRoot = forwardRef(
  function NativeSelectRoot2(props, ref) {
    const styles = useMultiStyleConfig("Select", props);
    const ownProps = omitThemingProps(props);
    const [fieldProps, localProps] = splitFieldProps(ownProps);
    const field = useField(fieldProps);
    return /* @__PURE__ */ jsx(SelectContextProvider, { value: field, children: /* @__PURE__ */ jsx(SelectStylesProvider, { value: styles, children: /* @__PURE__ */ jsx(
      chakra.div,
      {
        ref,
        className: "chakra-select",
        __css: styles.root,
        ...localProps,
        children: props.children
      }
    ) }) });
  }
);
NativeSelectRoot.displayName = "Select";

export { NativeSelectRoot };
